import { useClickhouseMediaAnalytics } from '@/utils/hooks/featureFlag/useClickhouseMediaAnalytics';

import { classNames } from '@/utils';

import PropTypes from 'prop-types';

import { DEFAULT_POST_CONFIG } from '@/lib/posts/defaultPostConfig';
import { getPostType, IG_POST_TYPES, STORY } from '@/lib/posts/postTypes';
//lib
import { INSTAGRAM } from '@/lib/socialProfile';

//components
import Post from '@/components/base/Post';
import HoverLabelAndAlbums from '@/components/base/Post/HoverLabelAndAlbums';
import LazyAnalyticsFooter from '@/components/base/Post/LazyAnalyticsFooter';

const InstagramStory = ({
    data,
    isLoading,
    config,
    openViewer,
    remoteMedia = false,
    isExport = false,
    postConfig = DEFAULT_POST_CONFIG,
    handleLabelsEvent,
    handleAlbumsEvent
}) => {
    const mergedPostConfig = { ...DEFAULT_POST_CONFIG, ...postConfig };
    const type = getPostType({ network: INSTAGRAM, type: data?.type });
    // v2 stories have type='story' and sub_type='photo'|'video'; analytics config keys on sub_type
    const analyticsType = data?.sub_type ?? type;
    const { isActiveForNetwork } = useClickhouseMediaAnalytics();
    const shouldUseLazyAnalytics = isActiveForNetwork(INSTAGRAM);

    if (isLoading) {
        return <Post.Placeholder postType={STORY} isExport={isExport} />;
    }

    return (
        <Post
            data={data}
            config={config}
            isLoading={isLoading}
            className={classNames('w-full bg-white px-1 pt-1', {
                'dark:bg-icoDarkMode-anthracite': !isExport
            })}
            isExport={isExport}>
            {({ referenceElement }) => (
                <>
                    <Post.Content className="w-full">
                        {mergedPostConfig?.hasHover ? (
                            <HoverLabelAndAlbums
                                openViewer={openViewer}
                                referenceElement={referenceElement}
                                handleLabelsEvent={handleLabelsEvent}
                                handleAlbumsEvent={handleAlbumsEvent}
                                showLabels={mergedPostConfig?.showLabels}
                                showAlbums={mergedPostConfig?.showAlbums}
                                postType={STORY}
                            />
                        ) : null}
                        {type && type !== IG_POST_TYPES.TYPE_PHOTO ? (
                            <Post.PostTypeIcon type={type} isExport={isExport} />
                        ) : null}
                        {data?.promoted_post ? (
                            <Post.MediaTags>
                                <Post.Promoted />
                            </Post.MediaTags>
                        ) : null}
                        <div className="story">
                            <Post.Image remoteMedia={remoteMedia} />
                        </div>
                    </Post.Content>
                    {mergedPostConfig?.hasFooter ? (
                        shouldUseLazyAnalytics && data?.id && data?.social_profile_id ? (
                            <LazyAnalyticsFooter
                                type={analyticsType}
                                mediaId={data.id}
                                socialProfileId={data.social_profile_id}
                                network={INSTAGRAM}
                            />
                        ) : (
                            <Post.Footer type={type} />
                        )
                    ) : null}
                </>
            )}
        </Post>
    );
};

InstagramStory.propTypes = {
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    openViewer: PropTypes.func,
    addLabel: PropTypes.func,
    addAlbum: PropTypes.func
};

export default InstagramStory;
